/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Internal_CategoryInputs */

const en_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Category`)
};

const es_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría interna`)
};

const fr_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie interne`)
};

const de_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Kategorie`)
};

const ja_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内部カテゴリ`)
};

const zh_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内部分类`)
};

const ar_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة الداخلية`)
};

const id_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori Internal`)
};

const it_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria Interna`)
};

const ru_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутренняя категория`)
};

const pt_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria Interna`)
};

const ko_internal_category = /** @type {(inputs: Internal_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내부 카테고리`)
};

/**
* | output |
* | --- |
* | "Internal Category" |
*
* @param {Internal_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const internal_category = /** @type {((inputs?: Internal_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Internal_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_internal_category(inputs)
	if (locale === "es") return es_internal_category(inputs)
	if (locale === "fr") return fr_internal_category(inputs)
	if (locale === "de") return de_internal_category(inputs)
	if (locale === "ja") return ja_internal_category(inputs)
	if (locale === "zh") return zh_internal_category(inputs)
	if (locale === "ar") return ar_internal_category(inputs)
	if (locale === "id") return id_internal_category(inputs)
	if (locale === "it") return it_internal_category(inputs)
	if (locale === "ru") return ru_internal_category(inputs)
	if (locale === "pt") return pt_internal_category(inputs)
	return ko_internal_category(inputs)
});